import { render, staticRenderFns } from "./SearchResultsCount.vue?vue&type=template&id=012490f2&"
import script from "./SearchResultsCount.vue?vue&type=script&lang=ts&"
export * from "./SearchResultsCount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports